import React from 'react';
import { ArrowLeft, Copy } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';
import { Order, OrderStatus } from '../../types/order';
import { formatDateTime } from '../../utils/date';

interface OrderHeaderProps {
  order: Order;
  handleBackNavigation: () => void;
  copyToClipboard: (text: string) => void;
  getStatusBadge: (status: OrderStatus) => React.ReactNode;
}

const OrderHeader: React.FC<OrderHeaderProps> = ({
  order,
  handleBackNavigation,
  copyToClipboard,
  getStatusBadge
}) => {
  return (
    <div className="mb-8">
      <button
        onClick={handleBackNavigation}
        className="inline-flex items-center text-sm text-gray-500 hover:text-gray-700 mb-6 group"
      >
        <ArrowLeft className="w-4 h-4 mr-2 transition-transform group-hover:-translate-x-1" />
        Back to Orders
      </button>

      <div className="space-y-6">
        {/* Top Line: Order ID, Time, and Status */}
        <div className="flex items-start justify-between">
          <div className="space-y-1">
            <div className="flex items-center gap-3">
              <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900">Order #{order.orderId}</h1>
              <button
                onClick={() => copyToClipboard(order.orderId)}
                className="p-1 text-gray-400 hover:text-indigo-600 transition-all"
                title="Copy Order ID"
              >
                <Copy className="w-5 h-5" />
              </button>
            </div>
            <p className="text-sm font-medium text-gray-500">
              Placed on {formatDateTime(order.createdAt)}
            </p>
          </div>
          <div className="flex-shrink-0">
            {getStatusBadge(order.status)}
          </div>
        </div>

        {/* Bottom Line: Customer Info and WhatsApp */}
        <div className="flex items-center justify-between">
          <div className="flex flex-col">
            <p className="text-lg font-bold text-gray-900 leading-tight">
              {order.shippingAddress.name}
            </p>
            <p className="text-sm text-gray-600 font-medium mt-0.5">
              {order.shippingAddress.mobile}
            </p>
          </div>
          <button
            onClick={() => {
              const cleaned = order.shippingAddress.mobile.replace(/\D/g, '');
              const whatsappNumber = cleaned.length === 10 ? `91${cleaned}` : cleaned;
              window.open(`https://wa.me/${whatsappNumber}`, '_blank');
            }}
            className="p-2.5 text-[#25D366] hover:bg-green-50 rounded-full transition-colors flex items-center justify-center"
            title="Chat on WhatsApp"
          >
            <FaWhatsapp className="w-6 h-6" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderHeader;
